// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__kLkPc","loader":"Loader_loader__j0Tkq","spinner":"Loader_spinner__QrU8H"};